module.exports = __webpack_public_path__ + "static/curated-community-9011f6c8cd38f78bcba8d541f024f218.jpg";